module.exports = __webpack_public_path__ + "img/flag.3705f408.png";